import React, { PropsWithChildren } from 'react';
import { SubmitHandler } from 'react-hook-form';

import { DialogFooter } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Icons } from '@/components/icons';

import CompanyFormStep from './steps/CompanyFormStep';
import { ICompanyFormSchema } from './steps/CompanyFormStep/schema';
import ResponsibleFormStep from './steps/ResponsibleFormStep';
import { ICompanyResponsibleFormSchema } from './steps/ResponsibleFormStep/schema';
import AddressFormStep from './steps/AddressFormStep';
import { ICompanyAddressFormSchema } from './steps/AddressFormStep/schema';
import { AddCompanyStep } from './steps';

interface IProps extends PropsWithChildren {
  isLoading: boolean;
  currentStep: AddCompanyStep;
  onPrevStep: () => void;
  onCompanySubmit: SubmitHandler<ICompanyFormSchema>;
  onResponsibleSubmit: SubmitHandler<ICompanyResponsibleFormSchema>;
  onAddressSubmit: SubmitHandler<ICompanyAddressFormSchema>;
}

const AddCompanyView: React.FC<IProps> = ({
  isLoading,
  currentStep,
  onPrevStep,
  onCompanySubmit,
  onResponsibleSubmit,
  onAddressSubmit,
}) => (
  <div>
    {currentStep.step === 'company' && (
      <CompanyFormStep
        defaultValues={currentStep.company}
        onSubmit={onCompanySubmit}
      >
        <DialogFooter>
          <Button type="submit">Proximo</Button>
        </DialogFooter>
      </CompanyFormStep>
    )}

    {currentStep.step === 'responsible' && (
      <ResponsibleFormStep
        defaultValues={currentStep.responsible}
        onSubmit={onResponsibleSubmit}
      >
        <DialogFooter>
          <Button variant="outline" onClick={onPrevStep}>
            Voltar
          </Button>
          <Button type="submit">Proximo</Button>
        </DialogFooter>
      </ResponsibleFormStep>
    )}

    {currentStep.step === 'address' && (
      <AddressFormStep onSubmit={onAddressSubmit}>
        <DialogFooter>
          <Button variant="outline" onClick={onPrevStep}>
            Voltar
          </Button>
          <Button type="submit" disabled={isLoading}>
            {isLoading && (
              <Icons.spinner className="mr-2 h-4 w-4 animate-spin" />
            )}
            Adicionar empresa
          </Button>
        </DialogFooter>
      </AddressFormStep>
    )}
  </div>
);

export default AddCompanyView;
